(ns common.schema.entities.workspace.kyc.templates.capman.tenant-ubo
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.templates :as templates]))

(def schema
  {:kyc-template/template-name
   "UBO"
   :kyc-template/kyc-form-preface
   {:translations {:en "Ultimate beneficial owners (UBO)"
                   :fi "Yhteisön tosiasialliset edunsaajat"}}

   :kyc-ubo.group/ubo-position
   {:ord          1.0
    :translations {:en "Reason for UBO"
                   :fi "Peruste"}
    :conditional-block (fn [_answers kyc-process]
                         (not (templates/natural-person-templates-keys (:kyc-process/template kyc-process))))
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/primary-ubo-category]
                    [:kyc-ubo/ubo-category-ownership]
                    [:kyc-ubo/ubo-category-voting-rights]
                    [:kyc-ubo/ubo-category-position]])}

   :kyc-ubo.group/basic-information
   {:ord          2.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-ubo/first-name]
                    [:kyc-ubo/last-name]
                    [:kyc-ubo/dob
                     {:mandatory-field? (fn [_answers kyc-process]
                                          (not= (:kyc-process/status kyc-process)
                                                :kyc-process.status/draft))}]
                    [:kyc-ubo/nationality]])}})
